import $ from "jquery";
import select2        from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

export default function(form) {
  $.ajax({
    url: '/backend/tenders/get_groups.json',
    dataType: 'json',
    data: form,
    success: (response) => {
      let results = []
      results = response.map(groupedStuff => {
        let key = groupedStuff[0]
        let options = groupedStuff[1]
        return {
          text: key,
          children: options.map(option => {
            return {
              id: option[1],
              text: option[0]
            }
          })
      }})
      $('#by_group_id').select2('destroy').empty().select2({data: results})
    },
    error: (xhr, text, error) => {
      swal({
        type: 'error',
        title: xhr.statusText
      })
    }
  });
}
